import {
  Box,
  Button,
  Divider,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { useState } from "react";
import SuggestedReviewer from "./SuggestedReviewer";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  },
  table: {
    minWidth: 650,
  },
  tableCell: {
    fontWeight: 600,
    color: "#4B4B4B",
  },
  secoundTypography: {
    color: "#4B4B4B",
    fontWeight: 600,
    marginRight: 20,
  },
  addButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.yellow.hover,
    },
    color: theme.palette.gif.yellow.dark,
    backgroundColor: theme.palette.gif.yellow.color,
  },
}));

const ProposalRow = (props) => {
  const classes = useStyles();
  const { proposalReferee } = props;
  const [proposalRefereeOpen, setProposalRefereeOpen] = useState(false);

  const openCloseSuggestedReviewers = () => {
    setProposalRefereeOpen(!proposalRefereeOpen);
  };

  return (
    <>
      <Modal open={proposalRefereeOpen}>
        <Box>
          <SuggestedReviewer
            proposalId={proposalReferee?.proposalId}
            openCloseSuggestedReviewers={() => setProposalRefereeOpen(false)}
          />
        </Box>
      </Modal>
      <TableRow key={proposalReferee.itemID}>
        <TableCell>{proposalReferee.proposalName}</TableCell>
        <TableCell>{proposalReferee.proposalTitle}</TableCell>
        <TableCell>{proposalReferee.proposalProgramtypeName}</TableCell>
        <TableCell>
          <Button
            disableElevation
            variant="contained"
            size="small"
            className={classes.addButton}
            onClick={openCloseSuggestedReviewers}
            disabled={proposalRefereeOpen}
          >
            + Add
          </Button>
        </TableCell>
      </TableRow>
    </>
  );
};

export default function DeclineReviews(props) {
  const classes = useStyles();
  const { proposalReferees } = props;
  const tableHeaders = [
    { label: "Proposal ID", size: "35%" },
    { label: "Title", size: "40%" },
    { label: "Program", size: "20%" },
    { label: "Reviewers", size: "5%" },
  ];

  return (
    <>
      <Typography fontWeight={600} color="#4B4B4B">Decline Reviews</Typography>
      <Divider />
      <Table
        stickyHeader
        className={classes.table}
        size="small"
        aria-label="caption table"
      >
        <TableHead>
          <TableRow>
            {tableHeaders.map((header) => (
              <TableCell
                className={classes.tableCell}
                key={header.label}
                align="left"
                style={{ width: header.size }}
              >
                {header.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {proposalReferees.map((proposalReferee) => (
            // <TableRow key={proposalReferee.itemID}>
            //   <TableCell>{proposalReferee.proposalName}</TableCell>
            //   <TableCell>{proposalReferee.proposalTitle}</TableCell>
            //   <TableCell>{proposalReferee.proposalProgramtypeName}</TableCell>
            // </TableRow>
            <ProposalRow  key={proposalReferee.itemID} proposalReferee={proposalReferee} />
          ))}
        </TableBody>
      </Table>
    </>
  );
}
